/* tslint:disable */
/* eslint-disable */
/**
 * rb-c3po-warehouse
 * API für die Verwaltung von Warenausgangsaufträgen, Artikeln, Chargen und Seriennummern
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Batch
 */
export interface Batch {
    /**
     * Eindeutige ID der Charge
     * @type {string}
     * @memberof Batch
     */
    id: string;
    /**
     * Chargennummer
     * @type {string}
     * @memberof Batch
     */
    batchNumber: string;
    /**
     * Ablaufdatum der Charge
     * @type {Date}
     * @memberof Batch
     */
    expiryDate: Date;
    /**
     * Verfügbare Menge in dieser Charge
     * @type {number}
     * @memberof Batch
     */
    availableQty: number;
}

/**
 * Check if a given object implements the Batch interface.
 */
export function instanceOfBatch(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "batchNumber" in value;
    isInstance = isInstance && "expiryDate" in value;
    isInstance = isInstance && "availableQty" in value;

    return isInstance;
}

export function BatchFromJSON(json: any): Batch {
    return BatchFromJSONTyped(json, false);
}

export function BatchFromJSONTyped(json: any, ignoreDiscriminator: boolean): Batch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'batchNumber': json['batchNumber'],
        'expiryDate': (new Date(json['expiryDate'])),
        'availableQty': json['availableQty'],
    };
}

export function BatchToJSON(value?: Batch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'batchNumber': value.batchNumber,
        'expiryDate': (value.expiryDate.toISOString().substr(0,10)),
        'availableQty': value.availableQty,
    };
}

